// Mock data for evaluation, course, and student based on JDL
export const mockEvaluation = {
    id: 1,
    name: "Introduction to Calculus Assessment",
    chapter: "Chapter 1: Limits and Continuity",
    conceptTopic: "Derivatives and Integrals",
    difficulty: "MED",
    source: "Textbook",
    numberOfQuestions: 6,
    maxTimeMinutes: 20,
    expiryDateTime: new Date(Date.now() + 86400000),
    isPractice: false,
    durationSeconds: null,
    isActive: true,
    createdDate: new Date(),
    updatedDate: new Date(),
    createdBy: "admin",
    updatedBy: "admin",
};

export const mockCourse = {
    id: 1,
    courseName: "Introduction to Calculus",
    curriculum: "Advanced Math",
    academicClass: "12th Grade",
    subject: "Mathematics",
    baseFee: 500,
    description: "A foundational course in single-variable calculus.",
    durationMonths: 4,
    startDate: new Date("2025-09-01"),
    endDate: new Date("2026-01-01"),
    isActive: true,
    createdDate: new Date(),
    updatedDate: new Date(),
    createdBy: "admin",
    updatedBy: "admin",
};

export const mockStudent = {
    id: 1,
    name: "Jane Doe",
    email: "jane.doe@example.com",
    gender: "FEMALE",
    curriculum: "Advanced Math",
    academicClass: "12th Grade",
    profilePictureUrl: "https://placehold.co/150x150",
    dateOfBirth: new Date("2007-05-20"),
    schoolName: "Springfield High School",
    enrollmentDate: new Date("2025-08-15"),
    parentEmail: "parent.jane@example.com",
    parentPhone: "555-1234",
    hasLearningDisability: false,
    isActive: true,
    createdDate: new Date(),
    updatedDate: new Date(),
    createdBy: "admin",
    updatedBy: "admin",
};

export const mockAssessment = {
    id: 1,
    subjectName: mockCourse.courseName,
    timerDuration: 2,
};

export const mockQuestions = [
    {
        id: 'q1',
        questionText: 'What is the derivative of $f(x) = x^2$?',
        questionType: 'MULTIPLE_CHOICE',
        details: [],
        answerChoices: [
            { id: 'c1', choiceText: '$2x$', isCorrect: true, hint: 'Use the power rule: $\\frac{d}{dx}x^n = nx^{n-1}$', explanation: 'The power rule states that the derivative of $x^n$ is $nx^{n-1}$. For $x^2$, the derivative is $2x^{2-1} = 2x$.' },
            { id: 'c2', choiceText: '$x$', isCorrect: false },
            { id: 'c3', choiceText: '$2$', isCorrect: false },
            { id: 'c4', choiceText: '$x^3/3$', isCorrect: false },
        ],
    },
    {
        id: 'q2',
        questionText: 'What is the integral of $f(x) = 2x$?',
        questionType: 'MULTIPLE_CHOICE',
        details: [],
        answerChoices: [
            { id: 'c5', choiceText: '$2$', isCorrect: false },
            { id: 'c6', choiceText: '$x^2 + C$', isCorrect: true, hint: 'Use the power rule for integration: $\\int x^n dx = \\frac{x^{n+1}}{n+1} + C$', explanation: 'By the power rule for integration, $\\int 2x dx = 2\\int x^1 dx = 2(\\frac{x^{1+1}}{1+1}) + C = 2(\\frac{x^2}{2}) + C = x^2 + C$.' },
            { id: 'c7', choiceText: '$x$', isCorrect: false },
            { id: 'c8', choiceText: '$2x^2$', isCorrect: false },
        ],
    },
    {
        id: 'q3',
        questionText: 'Match the function with its derivative.',
        questionType: 'MATCHING',
        details: [
            {
                questionLeft: 'Function,Derivative',
                questionRight: '$x^3$,$cos(x)',
            },
        ],
        answerChoices: [
            { id: 'c9', choiceText: '$3x^2$', isCorrect: true },
            { id: 'c10', choiceText: '$sin(x)$', isCorrect: true },
        ]
    },
    {
        id: 'q4',
        questionText: 'Table of values for $f(x) = x+1$.',
        questionType: 'QUESTION_TABLE',
        details: [
            {
                questionCsv: 'x,f(x)\n1,2\n2,3\n3,4',
            },
        ],
        answerChoices: [],
    },
    {
        id: 'q5',
        questionText: 'What is the value of $\\sum_{n=1}^{5} n^2$?',
        questionType: 'MATHS_CALCULATION',
        details: [
            {
                questionMarkup: '$1^2+2^2+3^2+4^2+5^2 = 1+4+9+16+25 = 55$',
            },
        ],
        answerChoices: [],
    },
    {
        id: 'q6',
        questionText: 'Explain the fundamental theorem of calculus.',
        questionType: 'OPEN_ENDED',
        details: [],
        answerChoices: [],
    },
];